import termsESRP from '../markdown/vouchers/minecraft/termsES_RP.md?raw'
import termsTicketboxESRP from '../markdown/vouchers/ticketbox/termsES_RP.md?raw'

export default {
  profile: {
    subSections: {
      mySavedAddresses: {
        empty: 'Acá podés ver tus direcciones guardadas',
        addNew: {
          subtitle: 'Encontrá una nueva dirección',
        },
        delete: {
          title: '¿Seguro que querés eliminar esta dirección?',
        },
        toast: {
          limitReached:
            'Alcanzaste el límite de direcciones guardadas. Eliminá una para agregar otra',
        },
      },
    },
  },
  checkout: {
    paymentResult: {
      freeOrder: {
        success: {
          title: '¡Pedido exitoso!',
          actions: {
            accept: 'Volver a la home',
          },
        },
      },
    },
  },
  pickupMethods: {
    areaSelection: {
      areas: {
        MOP: {
          step: {
            title: '¿Cómo preferís tu pedido?',
            subtitle: 'Elegí la opción que desees para que podamos prepararlo',
          },
          counterSelection: {
            counters: {
              title: '¿En qué mostrador querés retirar tu pedido?',
              subtitle: 'Elegí el mostrador que prefieras para retirar tu pedido en el restaurante',
            },
          },
        },
      },
    },
  },
  errors: {
    toast: {
      generic: 'Hubo un problema. Por favor, intentalo de nuevo más tarde',
    },
    alerts: {
      noCoverage: {
        title: 'McDelivery no está disponible ahora',
        body: 'Mientras tanto, podés hacer un pedido y retirarlo en el restaurante más cercano con Pedí y Retirá',
        accept: 'Pedí y Retirá',
        cancel: 'Intentar más tarde',
      },
      noRiders: {
        title: 'Nuestros repartidores están ocupados',
        body: 'Podés intentar más tarde o hacer un pedido y retirarlo con Pedí y Retirá',
        accept: 'Pedí y Retirá',
        cancel: 'Intentar más tarde',
      },
      areaNotFound: {
        title: 'El restaurante no está disponible para los productos seleccionados',
        body: 'Podés elegir otro restaurante o volver a tu pedido y cambiar los productos',
        accept: 'Volver a mi pedido',
        cancel: 'Cambiar restaurante',
      },
      productNotAvailable: {
        title: '¡La promoción ya finalizó!',
        body: 'Cambiá los productos de tu pedido para continuar con la compra',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      promotionNotFound: {
        title: '¡La promoción ya finalizó!',
        body: 'Cambiá los productos de tu pedido para continuar con la compra',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      limitPriceOrder: {
        title: 'El valor total de tu compra es demasiado alto',
        body: 'Has superado el límite permitido de {value}. Por favor, revisá los productos del carrito',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      platformNotValidForPromo: {
        title: 'Esta promoción no es compatible',
        body: 'Por favor, seleccioná otro método de pago para completar la compra',
        accept: 'Elegir otro método de pago',
        cancel: '',
      },
      restaurantNotLoyalty: {
        title: 'Este restaurante no participa de {value}',
        body: 'Para continuar, cambiá los productos de tu pedido o elegí otro restaurante. Si lo hacés, se vaciará tu carrito',
        accept: 'Volver a mi pedido',
        cancel: 'Cambiar restaurante',
      },
      limitedPromoProduct: {
        title: 'Tu pedido ya incluye productos con descuento',
        body: '¿Querés mantener los descuentos actuales o aplicar el nuevo código?',
        accept: 'Mantener descuentos',
        cancel: 'Aplicar nuevo código',
      },
      employeeDiscount: {
        title: 'Tu pedido ya tiene descuentos aplicados',
        body: '¿Querés reemplazar la promoción o agregar el producto sin descuento?',
        accept: 'Agregar sin descuento',
        cancel: 'Reemplazar promoción',
      },
      pickup_serviceNumberEmpty: {
        body: 'Tuvimos un problema al cargar el número que ingresaste. Por favor, intentalo de nuevo',
      },
      pickup_anyPickupAreaForThisOrderIsAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      pickup_orderPickupNotAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      pickup_areaNotAvailable: {
        body: 'Podés cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
      },
      cumulativePromotionsNotAllowed: {
        title: 'Tu pedido ya tiene descuentos aplicados',
        body: '¿Querés reemplazar la promoción o agregar el producto sin descuento?',
        accept: 'Agregar sin descuento',
        cancel: 'Reemplazar promoción',
      },
      autoApplicablePromotionNotAllowed: {
        title: 'Tu pedido ya incluye productos con descuento',
        body: '¿Querés mantener los descuentos actuales o aplicar el nuevo código?',
        accept: 'Mantener descuentos',
        cancel: 'Aplicar nuevo código',
      },
      pickup_counterNotAvailable: {
        body: 'El mostrador seleccionado no está disponible en este momento. Elegí otra opción para retirar tu pedido',
      },
      antifraudTemporalBlock: {
        body: 'No pudimos completar el pedido. Por favor, revisá los datos de tu tarjeta y volvé a intentarlo en otro momento',
      },
      cartEmpty: {
        body: 'Elegí tus productos favoritos y empezá a disfrutar',
      },
      fiscalFieldsRequired: {
        body: 'Por favor, comprobá los datos de tu factura y volvé a intentarlo',
      },
      addressRequired: {
        body: 'Tuvimos un problema para completar tu pedido. Por favor, volvé a intentarlo',
      },
      countryNotValid: {
        body: 'Tuvimos un problema para completar tu pedido. Por favor, intentalo de nuevo',
      },
      orderGeneric: {
        body: 'Tuvimos un problema para completar tu pedido. Por favor, intentalo de nuevo',
      },
    },
  },
  selectRestaurant: {
    DLV: {
      confirmAddress: 'Confirmá tu dirección',
      favorite: {
        formTitle: '¿Cómo querés guardar esta dirección?',
        fields: {
          alias: {
            label: 'Elegí un nombre para esta dirección',
          },
        },
      },
    },
  },
  alertDialog: {
    mcDeliveryError: {
      body: 'Mientras tanto, podés hacer un pedido y retirarlo en el restaurante más cercano con @:common.MOP',
    },
  },
  orders: {
    delivery: {
      description: 'Informá el código al repartidor únicamente al recibir tu pedido',
    },
    ongoingSteps: {
      pending: {
        subtitle: 'Completá el pago para iniciar tu pedido',
      },
      payment_pending_counter: {
        subtitle: 'Anunciate con tu número',
      },
      event_date: {
        DLV: {
          subtitle: 'Cuando llegue la fecha, indicá que querés recibir tu pedido',
        },
      },
      inform_aut_speaker: {
        subtitle: 'Anunciate con tu número',
      },
      delivering: {
        subtitle: '¡Preparate para disfrutarlo!',
      },
      delivered: {
        subtitle: 'Contanos cómo fue la experiencia',
      },
    },
    areas: {
      subtitle: {
        mopDualPoint: 'Retirá el pedido cuando veas tu número en pantalla',
        mop: 'Anunciate con tu número',
        aut: 'Compartí este código para que empecemos a preparar tu pedido',
      },
    },
    messages: {
      yappy:
        'Si tenés dudas sobre tu pedido realizado con Yappy, contactanos a través de nuestro chat',
    },
    toast: {
      orderUnappliedProducts:
        'La promoción fue añadida, pero no aplica a los productos de tu pedido',
    },
  },
  restaurantTooltipAlert: {
    farFromRestaurantWithOrder: 'Notamos que estás lejos del restaurante donde hiciste el pedido',
    farFromRestaurantWithoutOrder:
      'Notamos que estás lejos del restaurante donde hiciste el pedido. Podés cambiarlo presionando sobre la dirección',
  },
  enrollment: {
    Document: {
      warning: {
        title: 'Documento ya registrado',
        body: 'Este número de documento ya está registrado para el email {email}. Para más información, ponete en contacto con ',
      },
    },
  },
  vouchers: {
    minecraft: {
      title: 'Tenés disponibles',
      description: 'Podés obtener un código Minecraft si tenés los puntos necesarios',
      redeemCoupon: {
        title: '¿Querés canjear <br/><b>{value} pts.</b> para obtener <br/>un código?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabás de obtener tu código Minecraft',
        useCodeInfo: '¿Cómo usar los códigos?',
        codeExpiration: 'Tu código vence el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos minecraft',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title: 'Solo se permite activar un código por cuenta Minecraft',
        description:
          "Canjeá tus puntos desde el { startDate } al { endDate } o hasta agotar el stock de { stock } unidades. El código activa 25 complementos (Add-ons) de McDonald's en Minecraft: Bedrock Edition",
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Intentalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos Minecraft',
        noPointsAvailable:
          'No tenés los puntos necesarios para obtener un código. Necesitás { value } pts. para conseguirlo',
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste de la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    ticketbox: {
      title: 'Tenés disponibles',
      description: 'Después de confirmar el canje, activá tu código y elegí el cine',
      redeemCoupon: {
        title: '¿Querés canjear <br/><b>{value} pts.</b> para obtener <br/>un código?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabás de obtener tu código para canjear una entrada de cine',
        useCodeInfo: '¿Cómo activo los códigos?',
        codeExpiration: 'Tu código vence el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          'Podés activar el código en Ticket Box y seguir las instrucciones para recibir tu entrada',
        description:
          'Promoción válida desde el { startDate } hasta agotar stock de { stock } unidades. Activá tu código por entradas a los siguientes cines: Cinemark Hoyts, Cinemacenter, Atlas Cines, Cinépolis, Cinema Adrogué, Multiplex, Showcase Cinemas y Cinema Devoto. Podés consultar los Términos y Condiciones en el sitio:',
        link: 'https://www.mcdonalds.com.ar/terminos-y-condiciones-mimcine',
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Intentalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos de cine',
        noPointsAvailable:
          'No tenés los puntos necesarios para obtener un código. Necesitás { value } pts. para conseguirlo',
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste de la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
  },
  offers: {
    title: '¡Accedé a este cupón descargando nuestra app!',
    description: 'Aprovechá beneficios únicos y ofertas todos los días desde tu celular',
  },
  markdown: {
    vouchers: {
      minecraft: {
        terms: termsESRP,
      },
      ticketbox: {
        terms: termsTicketboxESRP,
      },
    },
  },
  loyalty: {
    title: 'Sumá puntos con { programName } y canjealos por recompensas. <br/> ¡Descargate la app!',
    description: 'Ahorrá con puntos, aprovechá promos y cupones que van con vos',
    link: 'Saber más sobre { programName }',
    name: 'Mi McDonald’s',
  },
  mandatoryTerms: {
    title: 'Aceptá los Términos y Condiciones para continuar',
    subtitle:
      'Necesitás leer y aceptar los Términos y Condiciones para seguir usando nuestras plataformas',
  },
}
